import React, { useState, useEffect } from 'react';
import { Loader2 } from 'lucide-react';

const funnyMessages = [
  "Recherche intense de jumeaux numériques…",
  "Deux prénoms identiques, une mission : les retrouver !",
  "Pendant ce temps, votre café refroidit.",
  "On compare, on scrute, on plisse les yeux.",
  "Un doublon par-ci, un doublon par-là…",
  "La chasse aux clones est ouverte !",
  "On fouille dans les archives comme un détective privé.",
  "Un instant, on vérifie si on ne s'est pas déjà rencontrés…",
  "On fait le tri comme dans une garde-robe de printemps.",
  "On joue au jeu des 7 différences, version CRM."
];

const LoadingOverlay: React.FC = () => {
  const [currentMessage, setCurrentMessage] = useState(0);
  const [fade, setFade] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(true);
      setTimeout(() => {
        setCurrentMessage((prev) => (prev + 1) % funnyMessages.length);
        setFade(false);
      }, 500);
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="fixed inset-0 bg-white/80 backdrop-blur-sm z-50 flex flex-col items-center justify-center">
      <div className="text-center space-y-4">
        <h2 className="text-2xl font-semibold text-primary mb-4">Recherche de doublons</h2>
        <Loader2 className="h-12 w-12 text-primary animate-spin mx-auto" />
        <p className={`text-lg text-primary transition-opacity duration-500 ${fade ? 'opacity-0' : 'opacity-100'}`}>
          {funnyMessages[currentMessage]}
        </p>
      </div>
    </div>
  );
};

export default LoadingOverlay; 